import { Navigate, useOutletContext } from "react-router-dom";

import Alert from "../../app/universalComponents/Alert";
import ErrorState from "../../app/universalComponents/ErrorState";

export default function DashboardIndex() {
    const { organiser, eventsList } = useOutletContext();

    if (eventsList.length > 0) {
        return <Navigate to={`${eventsList[0].slug}/overview`} replace />;
    }

    return (
        <div className="flex min-h-dvh flex-col">
            {organiser?.status !== "active" && (
                <Alert tone="neutral" className="w-full text-center">
                    You'll need to activate your Stripe account before creating an event
                </Alert>
            )}

            <ErrorState>
                No events yet. Create your first event to start tracking tickets, guests, and event performance.
            </ErrorState>
        </div>
    );
}